import type { Student } from '@mathflat/domain/Student'
import { type StrengthsAndWeaknesses, studentHomeApi } from '@mathflat/domain/StudentHome'
import { action, computed, makeObservable, observable } from 'mobx'
import SmileChallenge from 'src/@pages/home/@common/model/SmileChallenge.ts'

import { localStorageService } from '~/@common/services/storage.service.ts'

export default class SmileChallengeService {
  private _smileChallenge?: SmileChallenge

  constructor() {
    makeObservable<this, '_smileChallenge'>(this, {
      _smileChallenge: observable,
      isReady: computed,
      setSmileChallenge: action,
    })
  }

  get smileChallenge() {
    return this._smileChallenge
  }

  get isReady() {
    return this._smileChallenge !== undefined
  }

  private _getStudentId() {
    return localStorageService.user.studentId
  }

  async loadSmileChallenge(curriculumKey?: string) {
    const studentId = this._getStudentId()
    if (!studentId) {
      throw new Error('studentId required')
    }
    const data = await studentHomeApi.getStrengthsAndWeaknesses(
      studentId as Student['id'],
      curriculumKey,
    )
    this.setSmileChallenge(data)
  }

  setSmileChallenge(data: StrengthsAndWeaknesses | undefined) {
    if (data) {
      this._smileChallenge = new SmileChallenge(data)
    } else {
      this._smileChallenge = data
    }
  }
}
